import styled from "styled-components";

export const CustomSkeleton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  & div {
    margin: 20px;
    width: 100% !important;
    span {
      width: 100% !important;
    }
  }
`;

export const ImageContainer = styled.div`
  position: relative;

  img {
    &.bn-hover {
      opacity: 0;

      &.hidden {
        display: none;
      }
    }
  }
`;
